<script lang="ts">
  import { onMount } from "svelte"
  import { SyncLoader } from "svelte-loading-spinners"
  import { xhr, toast } from "$app/utils"
  import Honeybadger from "$app/utils/honeybadger"
  import Post from "./Post.svelte"
  import { appStore } from "$app/store.svelte"

  let isLoading = $state(true)

  onMount(async () => {
    loadUserPosts()
  })

  let permission_level = $state("none")
  let userPosts = $state([])

  async function loadUserPosts(): Promise<void> {
    isLoading = true

    try {
      const resp = await xhr.get(
        `/plans/${appStore.plan.id}/community_posts/user.json`
      )
      permission_level = resp.data.permission_level
      userPosts = resp.data.posts
    } catch (e) {
      isLoading = false
      if (typeof Honeybadger.notify !== "undefined") {
        Honeybadger.notify(e)
      }
      toast("There was an error loading your posts", "error")
    } finally {
      isLoading = false
    }
  }
</script>

<div class="bg-lwp-pale-grey py-6">
  <h1 class="text-3xl font-bold">Your Posts</h1>
  {#if isLoading}
    <div class="py-12 flex justify-center w-full">
      <SyncLoader size="240" color="#7572d2" unit="px" duration="1s" />
    </div>
  {:else}
    <ul role="list" class="mt-6 space-y-4 overflow-y-auto overflow-x-hidden">
      {#each userPosts as post}
        <Post {post} {permission_level} readOnly={false} showPinned={false} />
      {:else}
        <div class="px-8 py-4 border border-indigo-50 rounded shadow-lg">
          <p class="text-lg font-bold">You have not written any posts yet.</p>
        </div>
      {/each}
    </ul>
  {/if}
</div>
